// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@yaak/components/assets/icons/YaakIcons-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@yaak/components/assets/icons/YaakIcons-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@yaak/components/assets/icons/YaakIcons-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Icon Font';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}
@font-face {
  font-family: 'Icon Font Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}
@font-face {
  font-family: 'Icon Font Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}
.style__icon--MWVsY {
  font-family: 'Icon Font Medium';
  font-size: 1rem;
}
.style__iconregular--QY40M {
  font-family: 'Icon Font';
}
.style__iconlarge--RHK2t {
  font-size: 1.5rem;
}
.style__iconmedium--sd4Id {
  font-size: 1.25rem;
}
.style__iconAdd--YXkxk:before {
  content: '§';
}
.style__iconArrowBack--vJItY:before {
  content: '1';
}
.style__iconArrowForward--YaBMI:before {
  content: '5';
}
.style__iconArrowLeft--ueUFY:before {
  content: '1';
}
.style__iconArrowRight--DdN1Y:before {
  content: '5';
}
.style__iconBookmark--JxEbV:before {
  content: '0';
}
.style__iconCar--KuXDW:before {
  content: 'Å';
}
.style__iconArrowDropDown--ybsBk:before {
  content: '3';
}
.style__iconSuccess--Imgzu:before {
  content: '&';
}
.style__iconCheck--NxsR7:before {
  content: 'r';
}
.style__iconTime--zHBuB:before {
  content: '°';
}
.style__iconClose--pSHtM:before {
  content: 'p';
}
.style__iconCopy--cEDL7:before {
  content: '[';
}
.style__iconBarChart--lJ_6Y:before {
  content: '{';
}
.style__iconDelete--Equil:before {
  content: 'a';
}
.style__iconDuration--f6aJq:before {
  content: '®';
}
.style__iconEdit--ksk8u:before {
  content: 'd';
}
.style__iconEmail--XS7Mk:before {
  content: 'F';
}
.style__iconHelp--fIYs1:before {
  content: 'k';
}
.style__iconError--duScE:before {
  content: 'f';
}
.style__iconInstructor--JHxNh:before {
  content: '¾';
}
.style__iconBook--_3j7E:before {
  content: '}';
}
.style__iconLogout--i0hyz:before {
  content: 'c';
}
.style__iconMenuCollapse--dTzYa:before {
  content: 'b';
}
.style__iconMenu--hgCBg:before {
  content: 'v';
}
.style__iconPartner--qv6is:before {
  content: '¿';
}
.style__iconRole--lUKPH:before {
  content: 'Ï';
}
.style__iconFeelingSad--YTTVC:before {
  content: '¼';
}
.style__iconSearch--gcAhh:before {
  content: '±';
}
.style__iconSettings--ZDt9U:before {
  content: '!';
}
.style__iconStar--mdBjo:before {
  content: '%';
}
.style__iconStarFill--z0uRs:before {
  content: '^';
}
.style__iconStudent--lg1TK:before {
  content: 'Á';
}
.style__iconUser--xkXhf:before {
  content: 'Ã';
}
.style__iconSteeringWheel--Mtera:before {
  content: 'Ü';
}
.style__iconArrowDownward--yjj6b:before {
  content: '2';
}
.style__iconExpandMore--vdFg8:before {
  content: 'h';
}
.style__iconLanguage--zL6RF:before {
  content: '\\\\';
}
.style__iconDevice--qSbzh:before {
  content: '³';
}
.style__iconCheckList--ydaKg:before {
  content: 'Ñ';
}
.style__iconPhone--mtYQa:before {
  content: 'G';
}
.style__iconLink--bALMR:before {
  content: '\`';
}
.style__iconLinkOff--fZAJ7:before {
  content: 'z';
}
.style__iconCancel--h7ff_:before {
  content: 'q';
}
.style__iconPowerOnOff--o66mv:before {
  content: 'm';
}
.style__iconVideoCamera--COstj:before {
  content: '¸';
}
.style__iconUpdate--gyfpX:before {
  content: ')';
}
.style__iconLocation--vLWFq:before {
  content: 'Ç';
}
.style__iconLicensePlate--d_NEi:before {
  content: '×';
}
.style__iconExpandLess--nLSIQ:before {
  content: 'g';
}
.style__iconWarning--Fzya0:before {
  content: 'Q';
}
.style__iconVR--xdGuJ:before {
  content: '¹';
}
.style__iconPlay--FO4Zc:before {
  content: 'T';
}
.style__iconSkipNext--pLUIJ:before {
  content: 'U';
}
.style__iconSkipPrevious--H6F1g:before {
  content: 'à';
}
.style__iconPause--LpK03:before {
  content: 'R';
}
.style__iconReset--Hmkp9:before {
  content: 'Y';
}
`, "",{"version":3,"sources":["webpack://./../components/src/Icon/style.less"],"names":[],"mappings":"AAGE;EACE,wBAAA;EACA,2DAAA;AAFJ;AAME;EACE,+BAAA;EACA,2DAAA;AAJJ;AAQE;EACE,6BAAA;EACA,2DAAA;AANJ;AATA;EAoBI,+BAAA;EACA,eAAA;AARJ;AAUI;EACE,wBAAA;AARN;AAWI;EACE,iBAAA;AATN;AAYI;EACE,kBAAA;AAVN;AAtBA;EAqCI,YAAA;AAZJ;AAzBA;EAyCI,YAAA;AAbJ;AA5BA;EA6CI,YAAA;AAdJ;AA/BA;EAiDI,YAAA;AAfJ;AAlCA;EAqDI,YAAA;AAhBJ;AArCA;EAyDI,YAAA;AAjBJ;AAxCA;EA6DI,YAAA;AAlBJ;AA3CA;EAiEI,YAAA;AAnBJ;AA9CA;EAqEI,YAAA;AApBJ;AAjDA;EAyEI,YAAA;AArBJ;AApDA;EA6EI,YAAA;AAtBJ;AAvDA;EAiFI,YAAA;AAvBJ;AA1DA;EAqFI,YAAA;AAxBJ;AA7DA;EAyFI,YAAA;AAzBJ;AAhEA;EA6FI,YAAA;AA1BJ;AAnEA;EAiGI,YAAA;AA3BJ;AAtEA;EAqGI,YAAA;AA5BJ;AAzEA;EAyGI,YAAA;AA7BJ;AA5EA;EA6GI,YAAA;AA9BJ;AA/EA;EAiHI,YAAA;AA/BJ;AAlFA;EAqHI,YAAA;AAhCJ;AArFA;EAyHI,YAAA;AAjCJ;AAxFA;EA6HI,YAAA;AAlCJ;AA3FA;EAiII,YAAA;AAnCJ;AA9FA;EAqII,YAAA;AApCJ;AAjGA;EAyII,YAAA;AArCJ;AApGA;EA6II,YAAA;AAtCJ;AAvGA;EAiJI,YAAA;AAvCJ;AA1GA;EAqJI,YAAA;AAxCJ;AA7GA;EAyJI,YAAA;AAzCJ;AAhHA;EA6JI,YAAA;AA1CJ;AAnHA;EAiKI,YAAA;AA3CJ;AAtHA;EAqKI,YAAA;AA5CJ;AAzHA;EAyKI,YAAA;AA7CJ;AA5HA;EA6KI,YAAA;AA9CJ;AA/HA;EAiLI,YAAA;AA/CJ;AAlIA;EAqLI,YAAA;AAhDJ;AArIA;EAyLI,aAAA;AAjDJ;AAxIA;EA6LI,YAAA;AAlDJ;AA3IA;EAiMI,YAAA;AAnDJ;AA9IA;EAqMI,YAAA;AApDJ;AAjJA;EAyMI,YAAA;AArDJ;AApJA;EA6MI,YAAA;AAtDJ;AAvJA;EAiNI,YAAA;AAvDJ;AA1JA;EAqNI,YAAA;AAxDJ;AA7JA;EAyNI,YAAA;AAzDJ;AAhKA;EA6NI,YAAA;AA1DJ;AAnKA;EAiOI,YAAA;AA3DJ;AAtKA;EAqOI,YAAA;AA5DJ;AAzKA;EAyOI,YAAA;AA7DJ;AA5KA;EA6OI,YAAA;AA9DJ;AA/KA;EAiPI,YAAA;AA/DJ;AAlLA;EAqPI,YAAA;AAhEJ;AArLA;EAyPI,YAAA;AAjEJ;AAxLA;EA6PI,YAAA;AAlEJ;AA3LA;EAiQI,YAAA;AAnEJ;AA9LA;EAqQI,YAAA;AApEJ","sourcesContent":["@import '@yaak/components/src/spacing';\n\n:local {\n  @font-face {\n    font-family: 'Icon Font';\n    src: url('~@yaak/components/assets/icons/YaakIcons-Regular.woff')\n      format('woff');\n  }\n\n  @font-face {\n    font-family: 'Icon Font Medium';\n    src: url('~@yaak/components/assets/icons/YaakIcons-Medium.woff')\n      format('woff');\n  }\n\n  @font-face {\n    font-family: 'Icon Font Bold';\n    src: url('~@yaak/components/assets/icons/YaakIcons-Bold.woff')\n      format('woff');\n  }\n\n  .icon {\n    font-family: 'Icon Font Medium';\n    font-size: @spacing-100;\n\n    &regular {\n      font-family: 'Icon Font';\n    }\n\n    &large {\n      font-size: @spacing-150;\n    }\n\n    &medium {\n      font-size: @spacing-125;\n    }\n  }\n\n  .iconAdd:before {\n    content: '§';\n  }\n\n  .iconArrowBack:before {\n    content: '1';\n  }\n\n  .iconArrowForward:before {\n    content: '5';\n  }\n\n  .iconArrowLeft:before {\n    content: '1';\n  }\n\n  .iconArrowRight:before {\n    content: '5';\n  }\n\n  .iconBookmark:before {\n    content: '0';\n  }\n\n  .iconCar:before {\n    content: 'Å';\n  }\n\n  .iconArrowDropDown:before {\n    content: '3';\n  }\n\n  .iconSuccess:before {\n    content: '&';\n  }\n\n  .iconCheck:before {\n    content: 'r';\n  }\n\n  .iconTime:before {\n    content: '°';\n  }\n\n  .iconClose:before {\n    content: 'p';\n  }\n\n  .iconCopy:before {\n    content: '[';\n  }\n\n  .iconBarChart:before {\n    content: '{';\n  }\n\n  .iconDelete:before {\n    content: 'a';\n  }\n\n  .iconDuration:before {\n    content: '®';\n  }\n\n  .iconEdit:before {\n    content: 'd';\n  }\n\n  .iconEmail:before {\n    content: 'F';\n  }\n\n  .iconHelp:before {\n    content: 'k';\n  }\n\n  .iconError:before {\n    content: 'f';\n  }\n\n  .iconInstructor:before {\n    content: '¾';\n  }\n\n  .iconBook:before {\n    content: '}';\n  }\n\n  .iconLogout:before {\n    content: 'c';\n  }\n\n  .iconMenuCollapse:before {\n    content: 'b';\n  }\n\n  .iconMenu:before {\n    content: 'v';\n  }\n\n  .iconPartner:before {\n    content: '¿';\n  }\n\n  .iconRole:before {\n    content: 'Ï';\n  }\n\n  .iconFeelingSad:before {\n    content: '¼';\n  }\n\n  .iconSearch:before {\n    content: '±';\n  }\n\n  .iconSettings:before {\n    content: '!';\n  }\n\n  .iconStar:before {\n    content: '%';\n  }\n\n  .iconStarFill:before {\n    content: '^';\n  }\n\n  .iconStudent:before {\n    content: 'Á';\n  }\n\n  .iconUser:before {\n    content: 'Ã';\n  }\n\n  .iconSteeringWheel:before {\n    content: 'Ü';\n  }\n\n  .iconArrowDownward:before {\n    content: '2';\n  }\n\n  .iconExpandMore:before {\n    content: 'h';\n  }\n\n  .iconLanguage:before {\n    content: '\\\\';\n  }\n\n  .iconDevice:before {\n    content: '³';\n  }\n\n  .iconCheckList:before {\n    content: 'Ñ';\n  }\n\n  .iconPhone:before {\n    content: 'G';\n  }\n\n  .iconLink:before {\n    content: '`';\n  }\n\n  .iconLinkOff:before {\n    content: 'z';\n  }\n\n  .iconCancel:before {\n    content: 'q';\n  }\n\n  .iconPowerOnOff:before {\n    content: 'm';\n  }\n\n  .iconVideoCamera:before {\n    content: '¸';\n  }\n\n  .iconUpdate:before {\n    content: ')';\n  }\n\n  .iconLocation:before {\n    content: 'Ç';\n  }\n\n  .iconLicensePlate:before {\n    content: '×';\n  }\n\n  .iconExpandLess:before {\n    content: 'g';\n  }\n\n  .iconWarning:before {\n    content: 'Q';\n  }\n\n  .iconVR:before {\n    content: '¹';\n  }\n\n  .iconPlay:before {\n    content: 'T';\n  }\n\n  .iconSkipNext:before {\n    content: 'U';\n  }\n\n  .iconSkipPrevious:before {\n    content: 'à';\n  }\n\n  .iconPause:before {\n    content: 'R';\n  }\n\n  .iconReset:before {\n    content: 'Y';\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `style__icon--MWVsY`,
	"iconregular": `style__iconregular--QY40M`,
	"iconlarge": `style__iconlarge--RHK2t`,
	"iconmedium": `style__iconmedium--sd4Id`,
	"iconAdd": `style__iconAdd--YXkxk`,
	"iconArrowBack": `style__iconArrowBack--vJItY`,
	"iconArrowForward": `style__iconArrowForward--YaBMI`,
	"iconArrowLeft": `style__iconArrowLeft--ueUFY`,
	"iconArrowRight": `style__iconArrowRight--DdN1Y`,
	"iconBookmark": `style__iconBookmark--JxEbV`,
	"iconCar": `style__iconCar--KuXDW`,
	"iconArrowDropDown": `style__iconArrowDropDown--ybsBk`,
	"iconSuccess": `style__iconSuccess--Imgzu`,
	"iconCheck": `style__iconCheck--NxsR7`,
	"iconTime": `style__iconTime--zHBuB`,
	"iconClose": `style__iconClose--pSHtM`,
	"iconCopy": `style__iconCopy--cEDL7`,
	"iconBarChart": `style__iconBarChart--lJ_6Y`,
	"iconDelete": `style__iconDelete--Equil`,
	"iconDuration": `style__iconDuration--f6aJq`,
	"iconEdit": `style__iconEdit--ksk8u`,
	"iconEmail": `style__iconEmail--XS7Mk`,
	"iconHelp": `style__iconHelp--fIYs1`,
	"iconError": `style__iconError--duScE`,
	"iconInstructor": `style__iconInstructor--JHxNh`,
	"iconBook": `style__iconBook--_3j7E`,
	"iconLogout": `style__iconLogout--i0hyz`,
	"iconMenuCollapse": `style__iconMenuCollapse--dTzYa`,
	"iconMenu": `style__iconMenu--hgCBg`,
	"iconPartner": `style__iconPartner--qv6is`,
	"iconRole": `style__iconRole--lUKPH`,
	"iconFeelingSad": `style__iconFeelingSad--YTTVC`,
	"iconSearch": `style__iconSearch--gcAhh`,
	"iconSettings": `style__iconSettings--ZDt9U`,
	"iconStar": `style__iconStar--mdBjo`,
	"iconStarFill": `style__iconStarFill--z0uRs`,
	"iconStudent": `style__iconStudent--lg1TK`,
	"iconUser": `style__iconUser--xkXhf`,
	"iconSteeringWheel": `style__iconSteeringWheel--Mtera`,
	"iconArrowDownward": `style__iconArrowDownward--yjj6b`,
	"iconExpandMore": `style__iconExpandMore--vdFg8`,
	"iconLanguage": `style__iconLanguage--zL6RF`,
	"iconDevice": `style__iconDevice--qSbzh`,
	"iconCheckList": `style__iconCheckList--ydaKg`,
	"iconPhone": `style__iconPhone--mtYQa`,
	"iconLink": `style__iconLink--bALMR`,
	"iconLinkOff": `style__iconLinkOff--fZAJ7`,
	"iconCancel": `style__iconCancel--h7ff_`,
	"iconPowerOnOff": `style__iconPowerOnOff--o66mv`,
	"iconVideoCamera": `style__iconVideoCamera--COstj`,
	"iconUpdate": `style__iconUpdate--gyfpX`,
	"iconLocation": `style__iconLocation--vLWFq`,
	"iconLicensePlate": `style__iconLicensePlate--d_NEi`,
	"iconExpandLess": `style__iconExpandLess--nLSIQ`,
	"iconWarning": `style__iconWarning--Fzya0`,
	"iconVR": `style__iconVR--xdGuJ`,
	"iconPlay": `style__iconPlay--FO4Zc`,
	"iconSkipNext": `style__iconSkipNext--pLUIJ`,
	"iconSkipPrevious": `style__iconSkipPrevious--H6F1g`,
	"iconPause": `style__iconPause--LpK03`,
	"iconReset": `style__iconReset--Hmkp9`
};
export default ___CSS_LOADER_EXPORT___;
